import { render } from "./FooterCell.vue?vue&type=template&id=354df0ee"
import script from "./FooterCell.vue?vue&type=script&lang=js"
export * from "./FooterCell.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__